<template>
  <form @submit.prevent="changePassword" ref="form">
    <card>
      <h2 slot="header" class="card-title">{{$t('page_user.change_password')}}</h2>
      <div class="row">
        <div class="col-lg-3">
          <base-alert v-if="submitted && success" type="success" dismissible>
            <span>{{$t('page_user.password_success')}}</span>
          </base-alert>

          <base-input
            type="password"
            v-validate="'required'"
            data-vv-as="current password"
            name="current_password"
            :error="getError('current_password')"
            :label="$t('page_user.current_password')"
            :placeholder="$t('page_user.current_password')"
            v-model="model.currentPassword"
          >
          </base-input>
          <base-input
            type="password"
            v-validate="'required|min:5'"
            data-vv-as="new password"
            name="new_password"
            :error="getError('new_password')"
            :label="$t('page_user.new_password')"
            :placeholder="$t('page_user.new_password')"
            v-model="model.newPassword"
            ref="newPassword"
          >
          </base-input>
          <base-input
            type="password"
            v-validate="'required|confirmed:newPassword'"
            data-vv-as="confirm new password"
            name="confirm_new_password"
            :error="getError('confirm_new_password')"
            :label="$t('page_user.confirm_new_password')"
            :placeholder="$t('page_user.confirm_new_password')"
            v-model="model.confirmNewPassword"
          >
          </base-input>
        </div>

      </div>
      <base-button native-type="submit" type="primary" size="lg" class="btn-fill">
        {{$t('page_user.submit')}}
      </base-button>
    </card>
  </form>
</template>
<script>
  import {UserService} from '@/services';
  import {BaseAlert} from 'src/components';

  export default {
    data() {
      return {
        submitted: false,
        success: false,
        model: {}
      };
    },
    components: {
      BaseAlert
    },
    methods: {
      async changePassword() {

        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          this.submitted = false;
          this.success = false;
          let loader = this.$loading.show();
          await UserService.changePassword({
            currentPassword: this.model.currentPassword,
            newPassword: this.model.newPassword,
            confirmNewPassword: this.model.confirmNewPassword
          }).then((response) => {
            this.success = true;

          }).catch((error) => {
            let message = error.response.data.message;

            for (let key in message) {
              const fieldName = this._.snakeCase(key);
              const langKey = message[key];

              this.$validator.errors.add({
                field: fieldName,
                msg: this.$validator.dictionary.getMessage(this.$i18n.locale, langKey),
                regenerate: () => this.$validator.dictionary.getMessage(this.$i18n.locale, langKey)
              });
            }
          })

          this.$refs.form.reset();
          this.submitted = true;
          loader.hide();
        }
      },
      getError: function (fieldName) {
        return this.errors.first(fieldName);
      }
    }
  };
</script>
<style></style>
